export const actions = {
    GET_LIST_GLOBALIZATION: 'GET_LIST_GLOBALIZATION',
    SET_LIST_GLOBALIZATION: 'SET_LIST_GLOBALIZATION',
    UPDATE_GLOBALIZATION: 'UPDATE_GLOBALIZATION',
    REFRESH_GLOBALIZATION_LIST: 'REFRESH_GLOBALIZATION_LIST',
    DELETE_GLOBALIZATION: 'DELETE_GLOBALIZATION',
};